import { Injectable } from '@angular/core';

@Injectable()
export class LzSeoService {

  private pageInfo: any;

  constructor() {
    this.pageInfo = {
      'url': '',
      'title': 'ÐÐ»Ð°ÑÑÐ¾ÑÐ¼Ð° LIGA:ZAKON',
      'description': 'Ð¥Ð¼Ð°ÑÐ½Ð° Ð¿Ð»Ð°ÑÑÐ¾ÑÐ¼Ð° Ð´Ð»Ñ Ð·Ð°Ð¿ÑÑÐºÑ Ð²ÑÑÑ Ð¿ÑÐ¾Ð´ÑÐºÑÑÐ² ÐÐÐÐ:ÐÐÐÐÐ',
      'imgURL': '',
      'keywords': '',
      'canonical': {
        'isShow': false,
        'value': ''
      },
      'bookmarkTitle': '',
      'nextLink': '',
      'prevLink': ''
    };
  }

  public getInfo = () => {
    return this.pageInfo;
  }

  public setUrl = url => {
    this.pageInfo.url = url;
  }

  public setTitle = title => {
    this.pageInfo.title = title;
  }

  public setDescription = description => {
    this.pageInfo.description = description;
  }

  public setImg = imgURL => {
    this.pageInfo.imgURL = imgURL;
  }

  public setKeywords = keywords => {
    this.pageInfo.keywords = keywords;
  }

  public setNextLink = link => {
    this.pageInfo.nextLink = link;
  }

  public setPrevLink = link => {
    this.pageInfo.prevLink = link;
  }

  /**
   * Set custom properties to the object seo
   * @param prop - name of properties
   * @param value - data
   */
  public setProp = (prop, value) => {
    this.pageInfo[prop] = value;
  }

}
